$component-class: 'me-heading';
$heading-font-weight: map-get($font-weights, bold);
$heading-margin-bottom: var(--spacing-md);
$heading-font-sizes: (
  heading-1-sm: map-get($font-sizes, 5xl),
  // 40px
  heading-1-lg: map-get($font-sizes, 7xl),
  // 56px
  heading-2-sm: map-get($font-sizes, 4xl),
  // 36px
  heading-2-lg: map-get($font-sizes, 6xl),
  // 48px
  heading-3-sm: map-get($font-sizes, 3xl),
  // 32px
  heading-3-lg: map-get($font-sizes, 5xl),
  // 40px
  heading-4-sm: map-get($font-sizes, 2xl),
  // 24px
  heading-4-lg: map-get($font-sizes, 3xl),
  // 32px
  heading-5-sm: map-get($font-sizes, xl),
  // 20px
  heading-5-lg: map-get($font-sizes, 2xl),
  // 24px
  heading-6-sm: map-get($font-sizes, lg),
  // 18px
  heading-6-lg: map-get($font-sizes, xl), // 20px
);
$heading-line-heights: (
  heading-1-sm: map-get($line-heights, 2xl),
  heading-1-lg: map-get($line-heights, 2xl),
  heading-2-sm: map-get($line-heights, 2xl),
  heading-2-lg: map-get($line-heights, 2xl),
  heading-3-sm: map-get($line-heights, 2xl),
  heading-3-lg: map-get($line-heights, 2xl),
  heading-4-sm: map-get($line-heights, lg),
  heading-4-lg: map-get($line-heights, xl),
  heading-5-sm: map-get($line-heights, lg),
  heading-5-lg: map-get($line-heights, lg),
  heading-6-sm: map-get($line-heights, lg),
  heading-6-lg: map-get($line-heights, lg),
);

h1,
h2,
h3,
h4,
h5,
h6,
.#{$component-class} {
  font-style: normal;
  letter-spacing: normal;
  -webkit-font-smoothing: antialiased;
  font-weight: $heading-font-weight;
  margin: 0 0 $heading-margin-bottom;
}

#{$component-class}:last-child {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .#{$component-class} {
    margin-bottom: 0;
  }
}

@mixin generate-headings {
  @for $i from 1 through 6 {
    $size-key-sm: unquote('heading-#{$i}-sm');
    $size-key-lg: unquote('heading-#{$i}-lg');

    h#{$i},
    .#{$component-class}--#{$i} {
      font-size: map-get($heading-font-sizes, $size-key-sm);
      line-height: map-get($heading-line-heights, $size-key-sm);

      @include desktop {
        font-size: map-get($heading-font-sizes, $size-key-lg);
        line-height: map-get($heading-line-heights, $size-key-lg);
      }
    }
  }
}

@mixin generate-align-classes {
  @each $align in $aligns {
    .#{$component-class}--#{$align} {
      text-align: $align;
    }
  }
}

@include generate-align-classes;
@include generate-headings;
